// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'light',

  colors: {
    primary: "#FF0000",
    primary_low:"#FFF5F5",
    primary_high:"#8c0000",
    secondary: "#27272A",
    tertiary: "#3F3F46",

    red: {
      red_800: "#8c0000",
      red_50: "#FFF5F5"
    },

    gray: {
      gray_50: "#F4F4F5",
      gray_100: "#D4D4D8",
      gray_200: "#A1A1AA",
      gray_500: "#71717A",
      gray_600: "#52525B",
      gray_800: "#27272A",
    },

    white: "#FFFFFF",
    black: "#000000",
    blue: "#005DB4",
    purple: "#A624BA",

    success: '#24BA5B',
    warning: '#f97316',
    error: '#FF0000',
  }
};
